import React, { Component } from "react"
import * as path from "../../constants/Paths"
import QueryString from "query-string"
import config from "react-global-configuration"
import "../../../helpers/strings"
import BookingUpsale from "../common/BookingUpsale"

class CheckoutSummaryUpgradeOfferApproval extends Component {
  handleInputChange(event) {
    const { target } = event
    const value = target.checked
    const name = target.name
    let newConsentInformation = this.props.consentInformation

    newConsentInformation[name] = value
    this.props.updateCheckoutState("consentInformation", newConsentInformation, this.props.getRequiredFields())
  }

  renderItems(item, booking, variant, key, price, path, deletebGuid, carParkName = null) {
    const queryParams = QueryString.parse(this.props.location.search)
    if (deletebGuid) {
      delete queryParams.bguid
    }
    const thirdPartyPromoLabel = booking?.thirdPartyPromoLabelText

    return (
      <li key={key}>
        <p>
          {carParkName
            ? `${item.name} - ${carParkName}${thirdPartyPromoLabel ? ` - ${thirdPartyPromoLabel}` : ""}`
            : `${item.name}${thirdPartyPromoLabel ? ` - ${thirdPartyPromoLabel}` : ""}`}
          {variant && variant.name !== item.name ? ` - ${variant.name}` : ""}
        </p>
        <h4> {this.props.priceFormatter(price)}</h4>
      </li>
    )
  }

  hasRefund = (extras) => {
    return !!extras.find((e) => e.product.showBookingPage)
  }

  render() {
    const textKeys = config.get("textKeys.checkout.summary") || {}
    const consentTextKeys = config.get("textKeys.checkout.consent") || {}
    const amendmentUpgradeTextKeys = config.get("textKeys.amendment.upgrade") || {}
    const { booking, product, activeBookingExtraProducts, carPark, parking } = this.props.bookingResult
    const { termsAndConditionsContent, bookingUpsale, content, changeFromBooking } = this.props
    const upsaleHeadline = textKeys.upsaleHeadline || "Opgrader din parkering til {carParkName} {productName} for {price} ekstra"
    const hideRefundGuarantee = (product && product.dynamicFields && product.dynamicFields && product.dynamicFields.hideRefundGuarantee) || false
    let parkingPrice = parking.originalAmount ?? parking.amount // fallback to amount if originalAmount is null
    if (booking.promotionCode && booking.promotionSaving > 0) {
      parkingPrice = parking.originalAmount
    } else if (!!booking.affiliateCode && !booking.useMemberPrice && parking.amount < parking.originalAmount) {
      parkingPrice = parking.amount
    } else if (booking.useMemberPrice) {
      parkingPrice = parking.amount
    } else if (parking.isParkingUpgrade) {
      parkingPrice = parking.amount
    }
    const upgradeProductName = bookingUpsale && bookingUpsale.product.name

    const thirdPartyPromoLabel = booking?.thirdPartyPromoLabelText
    const cfThirdPartyPromoLabel = changeFromBooking?.thirdPartyPromoLabelText

    return (
      <div className="form--parking__calc" id="parkingFormCalc">
        {this.props.isUpgrade ? (
          <React.Fragment>
            <header className="form__header">
              <h4>{amendmentUpgradeTextKeys.refundHeader}</h4>
            </header>
            <ul className="form--parking__calc__list">
              <li>
                <p>
                  {changeFromBooking
                    ? `${changeFromBooking.product.name} - ${changeFromBooking.carPark.name}${cfThirdPartyPromoLabel ? ` - ${cfThirdPartyPromoLabel}` : ""}`
                    : ""}
                </p>
                <h4> {changeFromBooking ? this.props.priceFormatter(changeFromBooking.booking.price) : ""}</h4>
              </li>
            </ul>
            <br />
            <header className="form__header">
              <h4>{amendmentUpgradeTextKeys.newReservationHeader}</h4>
            </header>
            <ul className="form--parking__calc__list">
              <li>
                <p>{product ? `${product.name} - ${carPark.name}${thirdPartyPromoLabel ? ` - ${thirdPartyPromoLabel}` : ""}` : ""}</p>
                <h4> {this.props.priceFormatter(parkingPrice)}</h4>
              </li>
            </ul>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <header className="form__header">
              <h4>{this.props.header}</h4>
            </header>
            <ul className="form--parking__calc__list">
              {this.renderItems(product, booking, undefined, product.id, parkingPrice, path.SEARCH(), true, carPark.name)}
              {activeBookingExtraProducts.length > 0
                ? activeBookingExtraProducts.map((extra, index) => {
                    const extraPrice = this.props.getExtraPrice(extra.product, booking)
                    return this.renderItems(extra.product, undefined, extra.variants[0].productOffer, index, extraPrice, path.EXTRA_SERVICES())
                  })
                : ""}
              {!booking.promotionCode || booking.promotionSaving === 0 ? (
                ""
              ) : (
                <li>
                  <p>
                    {textKeys.promotionCode || "Kampagnekode"}: {booking.promotionName}
                  </p>
                  <h4>-{this.props.priceFormatter(booking.promotionSaving)}</h4>
                </li>
              )}
            </ul>
            {this.props.isUpsold ? null : bookingUpsale ? <BookingUpsale {...this.props} {...this.state} /> : null}
          </React.Fragment>
        )}

        <div className="form__section form__section--short form__section--light">
          <div className="form__section__inner">
            <div className={"form__field form__field--checkbox is-required is-bound"}>
              <label className="form__label">
                <input
                  className="form__item "
                  id={termsAndConditionsContent.consentId}
                  name={termsAndConditionsContent.consentId}
                  type="checkbox"
                  checked={this.props.consentInformation[termsAndConditionsContent.consentId] || false} //{item.isPreselected}
                  onChange={(event) => this.handleInputChange(event)}
                />
                <span className="form__label__text">
                  <span dangerouslySetInnerHTML={{ __html: termsAndConditionsContent.body }}></span>
                </span>
              </label>
            </div>
          </div>
        </div>
        <br />
        {!this.props.consentInformation[termsAndConditionsContent.consentId] && this.props.checkoutErrors.showErrors ? (
          <span className={"form__notice form__notice--box is-invalid"}>{textKeys.required || "Du skal udfylde dette felt"}</span>
        ) : (
          ""
        )}
        {consentTextKeys.privacy ? <div className="privacy-text" dangerouslySetInnerHTML={{ __html: consentTextKeys.privacy }}></div> : ""}
      </div>
    )
  }
}
export default CheckoutSummaryUpgradeOfferApproval
